import { config } from '@/config'
import loadScript from '@/utils/loadscript';

let scriptLoaded = false;
let scriptLoading = false;

export function isRecaptchaConfigured() {
	return !!config.THEME_RECAPTCHA_SITE_KEY;
}

export async function loadRecaptcha() {
	if (isRecaptchaConfigured() && !scriptLoaded && !scriptLoading) {
		try {
			scriptLoading = true;
			await loadScript(`https://www.google.com/recaptcha/api.js?render=${config.THEME_RECAPTCHA_SITE_KEY}`);
			scriptLoading = false;
			scriptLoaded = true;
		}
		catch {}
	}
}

export async function getRecaptchaResponse(fn = () => {}) {
	return new Promise((resolve, reject) => {
		if (isRecaptchaConfigured() && (!scriptLoaded || !grecaptcha)) {
			return reject(new Error())
		}
		else if (!isRecaptchaConfigured()) {
			return resolve(null)
		}

		grecaptcha.ready(async () => {
			const recaptchaResponse = await grecaptcha.execute(config.THEME_RECAPTCHA_SITE_KEY, {action: 'submit'})

			if (!recaptchaResponse) {
				return reject(new Error())
			}

			return resolve(recaptchaResponse)
		});
	})
}
